import { render, staticRenderFns } from "./Fundraiser.vue?vue&type=template&id=cf59854a&"
import script from "./Fundraiser.vue?vue&type=script&lang=js&"
export * from "./Fundraiser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports